import type { TeamTicketStats } from '../../../types/team';

interface TeamTicketCountsProps {
  stats?: TeamTicketStats;
  /** A parent's numbers include its sub-teams, and it has a waiting queue. */
  isParent: boolean;
}

/**
 * The ticket numbers on a team card: open, created today and SLA breached.
 * A parent's numbers cover its sub-teams too, and it also shows how many
 * tickets are waiting in its own queue for triage. Shows nothing until the
 * counts have loaded.
 */
export function TeamTicketCounts({ stats, isParent }: TeamTicketCountsProps) {
  if (!stats) return null;
  const items = [
    { label: 'Open', value: stats.openTickets },
    { label: 'Today', value: stats.createdToday },
    { label: 'SLA breached', value: stats.slaBreached, alert: stats.slaBreached > 0 },
    ...(isParent ? [{ label: 'Waiting in queue', value: stats.waitingInQueue, alert: false }] : []),
  ];
  return (
    <dl
      className="mt-4 grid grid-cols-3 gap-2 rounded-lg bg-gray-50 p-3 text-center dark:bg-gray-800/60"
      data-testid="team-ticket-counts"
    >
      {items.map((item) => (
        <div key={item.label} className={item.label === 'Waiting in queue' ? 'col-span-3' : undefined}>
          <dt className="text-[11px] text-gray-500 dark:text-gray-400">{item.label}</dt>
          <dd
            className={`text-base font-semibold ${
              item.alert ? 'text-red-600 dark:text-red-400' : 'text-gray-900 dark:text-gray-100'
            }`}
          >
            {item.value}
          </dd>
        </div>
      ))}
    </dl>
  );
}
